<div class="panel panel-default" *ngIf="model">
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-8">
        <h3 class="panel-title">Interchange Configuration</h3>
      </div>
      <div class="col-xs-4">
        <label class="pull-right">
          <button
            type="button"
            class="btn btn-default pull-right"
            (click)="clearInterchangeConfig()"
          >
            Clear All
          </button>
        </label>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">ISA05 Sender Id Qualifier</label>
          <select
            type="text"
            class="form-control"
            name="ISA05SenderIdQualifier"
            [(ngModel)]="model.InterchangeConfiguration.ISA05SenderIdQualifier"
          >
            <option></option>
            <option *ngFor="let ISAValue of ISAValues" [value]="ISAValue">{{ ISAValue }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">ISA06 Sender Id</label>
          <input
            type="text"
            class="form-control"
            name="ISA06SenderId"
            [(ngModel)]="model.InterchangeConfiguration.ISA06SenderId"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">ISA07 Receiver Id Qualifier</label>
          <select
            type="text"
            class="form-control"
            name="ISA07ReceiverIdQualifier"
            [(ngModel)]="model.InterchangeConfiguration.ISA07ReceiverIdQualifier"
          >
            <option></option>
            <option *ngFor="let ISAValue of ISAValues" [value]="ISAValue">{{ ISAValue }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">ISA08 Receiver Id</label>
          <input
            type="text"
            class="form-control"
            name="ISA08ReceiverId"
            [(ngModel)]="model.InterchangeConfiguration.ISA08ReceiverId"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-8">
        <h3 class="panel-title">Payer</h3>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Address Configuration</h3>
          </div>
          <div class="col-xs-4">
            <label class="pull-right">
              <button
                type="button"
                class="btn btn-default pull-right"
                (click)="clearPayerAddressConfig()"
              >
                Clear All
              </button>
            </label>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Address 1</label>
              <input
                type="text"
                class="form-control"
                name="AddressLine1"
                [(ngModel)]="model.PayerAddressConfiguration.AddressLine1"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Address 2</label>
              <input
                type="text"
                class="form-control"
                name="AddressLine2"
                [(ngModel)]="model.PayerAddressConfiguration.AddressLine2"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">City</label>
              <input
                type="text"
                class="form-control"
                name="CityName"
                [(ngModel)]="model.PayerAddressConfiguration.CityName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">State</label>
              <app-select
                #payerStateList
                [items]="states"
                [allowClear]="true"
                [selected]="selectedPayerState"
                [removed]="selectedPayerState"
                placeholder="Select a State"
              >
              </app-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">State Code</label>
              <input
                type="text"
                class="form-control"
                name="StateCode"
                [(ngModel)]="model.PayerAddressConfiguration.StateCode"
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Zip Code</label>
              <input
                type="text"
                class="form-control"
                name="PostalCode"
                [(ngModel)]="model.PayerAddressConfiguration.PostalCode"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Additional Information Configuration</h3>
          </div>
          <div class="col-xs-4">
            <label class="pull-right">
              <button
                type="button"
                class="btn btn-default pull-right"
                (click)="clearPayerAdditionalInfoConfig()"
              >
                Clear All
              </button>
            </label>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Reference Identification Qualifier</label>
              <input
                type="text"
                class="form-control"
                name="ReferenceIdentificationQualifier"
                [(ngModel)]="
                  model.PayerAdditionalInformationConfiguration.ReferenceIdentificationQualifier
                "
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Reference Identification</label>
              <input
                type="text"
                class="form-control"
                name="ReferenceIdentification"
                [(ngModel)]="model.PayerAdditionalInformationConfiguration.ReferenceIdentification"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Identification Configuration</h3>
          </div>
          <div class="col-xs-4">
            <label class="pull-right">
              <button
                type="button"
                class="btn btn-default pull-right"
                (click)="clearPayerIdentificationConfig()"
              >
                Clear All
              </button>
            </label>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input
                type="text"
                class="form-control"
                name="Name"
                [(ngModel)]="model.PayerIdentificationConfiguration.Name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Technical Contact Information Configuration</h3>
          </div>
          <div class="col-xs-4">
            <label class="pull-right">
              <button
                type="button"
                class="btn btn-default pull-right"
                (click)="clearPayerTechnicalContactInformationConfig()"
              >
                Clear All
              </button>
            </label>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input
                type="text"
                class="form-control"
                name="Name"
                [(ngModel)]="model.PayerTechnicalContactInformationConfiguration.Name"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Communication Number</label>
              <input
                type="text"
                class="form-control"
                name="CommunicationNumber"
                [(ngModel)]="
                  model.PayerTechnicalContactInformationConfiguration.CommunicationNumber
                "
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Communication Number Extension</label>
              <input
                type="text"
                class="form-control"
                name="CommunicationNumberExtension"
                [(ngModel)]="
                  model.PayerTechnicalContactInformationConfiguration.CommunicationNumberExtension
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-8">
        <h3 class="panel-title">Payee</h3>
        <i class="text-danger">Information editable from demographics</i>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="panel-title">Address Configuration</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Address 1</label>
              <input
                type="text"
                class="form-control"
                name="AddressLine1"
                [(ngModel)]="model.PayeeAddressConfiguration.AddressLine1"
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Address 2</label>
              <input
                type="text"
                class="form-control"
                name="AddressLine2"
                [(ngModel)]="model.PayeeAddressConfiguration.AddressLine2"
                disabled
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">City</label>
              <input
                type="text"
                class="form-control"
                name="CityName"
                [(ngModel)]="model.PayeeAddressConfiguration.CityName"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">State</label>
              <app-select
                #payeeStateList
                [items]="states"
                [selected]="selectedPayeeState"
                [removed]="selectedPayeeState"
                placeholder="Select a State"
                [disabled]="true"
              >
              </app-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">State Code</label>
              <input
                type="text"
                class="form-control"
                name="StateCode"
                [(ngModel)]="model.PayeeAddressConfiguration.StateCode"
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Zip Code</label>
              <input
                type="text"
                class="form-control"
                name="PostalCode"
                [(ngModel)]="model.PayeeAddressConfiguration.PostalCode"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="panel-title">Additional Information Configuration</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Reference Identification Qualifier</label>
              <input
                type="text"
                class="form-control"
                name="ReferenceIdentificationQualifier"
                [(ngModel)]="
                  model.PayeeAdditionalInformationConfiguration.ReferenceIdentificationQualifier
                "
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Reference Identification</label>
              <input
                type="text"
                class="form-control"
                name="ReferenceIdentification"
                [(ngModel)]="model.PayeeAdditionalInformationConfiguration.ReferenceIdentification"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="panel-title">Identification Configuration</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input
                type="text"
                class="form-control"
                name="Name"
                [(ngModel)]="model.PayeeIdentificationConfiguration.Name"
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Identification Code</label>
              <input
                type="text"
                class="form-control"
                name="IdentificationCode"
                [(ngModel)]="model.PayeeIdentificationConfiguration.IdentificationCode"
                [disabled]="true"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Identification Code Qualifier</label>
              <input
                type="text"
                class="form-control"
                name="IdentificationCodeQualifier"
                [(ngModel)]="model.PayeeIdentificationConfiguration.IdentificationCodeQualifier"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-8">
          <h3 class="panel-title">Banking Configuration</h3>
        </div>
        <div class="col-xs-4">
          <label class="pull-right">
            <button type="button" class="btn btn-default pull-right" (click)="clearBankingConfig()">
              Clear All
            </button>
          </label>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Payer</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">BPR07 Payer Routing Number</label>
              <input
                type="text"
                class="form-control"
                name="BPR07PayerRoutingNumber"
                [(ngModel)]="model.BankingConfiguration.BPR07PayerRoutingNumber"
                (keypress)="numberOnly($event)"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">BPR09 Payer Account Number</label>
              <input
                type="text"
                class="form-control"
                name="BPR09PayerAccountNumber"
                [(ngModel)]="model.BankingConfiguration.BPR09PayerAccountNumber"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">BPR10 Payer Identifier (JV Tax ID)</label>
              <input
                type="text"
                class="form-control"
                name="BPR10PayerIdentifier"
                [(ngModel)]="model.BankingConfiguration.BPR10PayerIdentifier"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Payee</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">BPR13 Payee Routing Number</label>
              <input
                type="text"
                class="form-control"
                name="BPR13PayeeRoutingNumber"
                [(ngModel)]="model.BankingConfiguration.BPR13PayeeRoutingNumber"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">BPR15 Payee Account Number</label>
              <input
                type="text"
                class="form-control"
                name="BPR15PayeeAccountNumber"
                [(ngModel)]="model.BankingConfiguration.BPR15PayeeAccountNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
